import { getCurrentLanguage } from '@eureka/language-tool'
import { REGION } from '@eureka/utils/environment'
import { DeployEnv } from '@patsnap-utils/biz'
import psHttp from '@patsnap/common-ps-http'
import {
    createCreditsChargeSdk,
    type CreditsChargeLocale,
    type CreditsChargeResult,
} from '@patsnap/credits-charge'

const IS_OVERSEA = [DeployEnv.US, DeployEnv.EU].includes(REGION)

let creditsChargePromise: Promise<CreditsChargeResult> | undefined

function normalizeCreditsLocale(value: string): CreditsChargeLocale {
    if (value === 'cn' || value === 'en' || value === 'jp' || value === 'tw') return value
    return 'en'
}

export function checkAndClaimCredits(): Promise<CreditsChargeResult | undefined> {
    if (!IS_OVERSEA) return Promise.resolve(undefined)
    if (creditsChargePromise) return creditsChargePromise

    const creditsChargeSdk = createCreditsChargeSdk({
        baseURL: process.env.VUE_APP_EUREKA_SERVICE_URI as string,
        http: psHttp,
        locale: normalizeCreditsLocale(getCurrentLanguage()),
    })
    const request = creditsChargeSdk.checkAndClaim()
    creditsChargePromise = request

    request.then(result => {
        // 请求异常时允许页面内的后续入口重试；其他结果在本次页面生命周期内复用。
        if (result.status === 'error' && creditsChargePromise === request) {
            creditsChargePromise = undefined
        }
    })

    return request
}
